"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const drippingService_1 = __importDefault(require("../services/drippingService"));
const useQuizzesByModule = (moduleId, currentPageId) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [quizzesByModule, setQuizzesByModule] = (0, react_1.useState)([]);
    const options = (0, react_1.useMemo)(() => {
        const isNotCurrentPage = (quiz) => quiz.id !== currentPageId;
        return quizzesByModule.map((module) => ({
            label: module.name,
            options: module.quizzes.filter(isNotCurrentPage).map((quiz) => ({
                label: quiz.name,
                value: quiz.id
            }))
        }));
    }, [quizzesByModule, currentPageId]);
    const quizzesById = (0, react_1.useMemo)(() => {
        const _quizzesById = {};
        quizzesByModule.forEach((module) => {
            module.quizzes.forEach((quiz) => {
                _quizzesById[quiz.id] = quiz;
            });
        });
        return _quizzesById;
    }, [quizzesByModule]);
    (0, react_1.useEffect)(() => {
        drippingService_1.default.fetchQuizzesByModule(moduleId).then((data) => {
            setQuizzesByModule(data);
            setIsLoading(false);
        });
    }, [moduleId]);
    return {
        quizzesByModule,
        quizzesById,
        options,
        isLoading
    };
};
exports.default = useQuizzesByModule;
